import { render, staticRenderFns } from "./campaign-closed.vue?vue&type=template&id=a56726b0&"
import script from "./campaign-closed.vue?vue&type=script&lang=js&"
export * from "./campaign-closed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports